import React from 'react';
import { Modal } from '@app/src/common/Modal';
import { useSelector } from 'react-redux';
import {
  Wrapper,
  Head,
  Content,
  IconClose,
  Operation,
  Description,
  Date,
  Extracharges,
  ItemExtra,
  LoaderWrapper
} from './styled';
import { Icon } from '@app/src/common/Icon';
import { PrintDateModel } from '@app/src/views/MyAccount/listAvailable';

interface Props {
  handleCloseModal?: Function;
  isDisplay: boolean;
}

export const ModalAvailableDetail: React.FC<Props> = ({
  handleCloseModal,
  isDisplay
}) => {
  const isLoading = useSelector(state => state.announcementDetail.isFetching);
  const title = useSelector(state => state.announcementDetail.data.title);
  const printDates = useSelector(state => state.announcementDetail.data.printDates);
  const extracharges = useSelector(state => state.announcementDetail.data.extracharges);

  return (
    <React.Fragment>
      <Modal show={isDisplay} closeModal={handleCloseModal} customBody>
        <Wrapper>
          <Head>
            Detalle del aviso
            <IconClose onClick={handleCloseModal}>
              <Icon data-name="icon-close-bold" fill="#f2f2f2" width="14" height="14" />
            </IconClose>
          </Head>
          {
            isLoading ?
              <LoaderWrapper>
                <Icon data-name='icon-circle' fill='#ccc' width={'16'} height={'16'} />
              </LoaderWrapper>
              :
              <Content>
                <Operation>{title}</Operation>
                <Description>Fecha(s) de publicación</Description>
                {
                  printDates && printDates.length > 0 && printDates.map((item: PrintDateModel, index) => (
                    <Date key={index}>{item.publication} - {item.datePrint}</Date>
                  ))
                }
                <Description>Extracargo(s)</Description>
                <Extracharges>
                  {
                    extracharges && extracharges.length > 0 && extracharges.map((extra, index) =>
                      <ItemExtra key={index}>{extra}</ItemExtra>
                    )
                  }
                </Extracharges>
              </Content>
          }
        </Wrapper>
      </Modal>
    </React.Fragment>
  );
};